import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-left">
        © 2025 Swayam Homes (P) Ltd. All rights reserved.
      </div>
      <div className="footer-right">
        Made with <span>♥</span> in Hyderabad
      </div>
    </footer>
  );
};

export default Footer;
